import { ChipField, ReferenceArrayField, SingleFieldList } from "react-admin";
import { Accordion, AccordionDetails, AccordionSummary, Typography } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { MobileListRow } from "features/MobileListRow";
import { studentRequests } from "api/studentApi";

export const FailedDisciplinesMobilePanel = () => (
  <Accordion sx={{ width: "100%" }}>
    <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ color: "#4E2683" }} />}>
      <Typography sx={{ fontWeight: "bold" }}>Детайли</Typography>
    </AccordionSummary>
    <AccordionDetails sx={{ width: "100%" }}>
      <MobileListRow
        fields={[
          {
            value: (
              <ReferenceArrayField
                reference={studentRequests.getCurriculumDisciplinesSelect()}
                source="failedDisciplineIds"
              >
                <SingleFieldList linkType={false}>
                  <ChipField source="name" />
                </SingleFieldList>
              </ReferenceArrayField>
            ),
          },
        ]}
      />
    </AccordionDetails>
  </Accordion>
);
